<template>
    <div class="search">
        <!-- search icon on header -->
        <v-btn flat @click="open_search()" :class="color" :loading="loading">
            <v-icon>search</v-icon>
        </v-btn>
        <!-- menu with results -->
        <v-menu offset-y ref="menu">
            <v-text-field
                v-show="search_active"
                placeholder="Taper au moins 2 caractères"
                v-model="search"
                hide-details
                :loading="loading"
                :hint="hint"
                type="text"
                ref="input"
                slot="activator"
                @blur="unfocused()"
                >
            </v-text-field>
            <!-- display pasts search that stored in the localstorage -->
            <!-- #region - pastSearches -->
            <div class="last_search" v-if="!search && pastSearches">
                <v-list>
                    <v-list-tile v-for="(pastSearch, index) in pastSearches" :key="index" :class="pastSearch.first_name ?  'profile' : 'category'" @click="oldSearch(pastSearch.route, pastSearch.id, pastSearch.group)">
                        <v-icon>search</v-icon>
                        <div>
                            <p>{{ pastSearch.label }}</p>
                        </div>
                    </v-list-tile>
                </v-list>
            </div>
            <!-- #endregion -->

            <template v-else>
                <!-- list of results -->
                <template v-if="search != null && result.projects && result.products">
                    <div class="active_search">

                        <!-- #region - projects -->
                        <v-subheader v-if="result.projects.length > 0">
                            Projets ({{ result.projects.length }})
                            <v-spacer></v-spacer>
                        </v-subheader>
                        <v-list v-if="result.projects.length > 0">
                            <v-list-tile v-for="(projects, index) in result.projects.slice(0, 3)" :key="index" @click="searchClick(projects, 'project', projects.id)" class="li">
                                <avatar :item="projects"></avatar>
                                <div>
                                    <p>{{projects.label}}</p>
                                    <span>{{$_.find(ProjectStatuses,p => p.value == projects.status).label}}</span>
                                </div>
                            </v-list-tile>
                        </v-list>
                        <!-- #endregion -->

                        <!-- #region - products -->
                        <v-subheader v-if="result.products.filter(p => p.group == 'consumable' || p.group == 'equipment' || p.group == 'accessory').length > 0">
                            Produits ({{ result.products.filter(p => p.group == 'consumable' || p.group == 'equipment' || p.group == 'accessory').length }})
                            <v-spacer></v-spacer>
                        </v-subheader>
                        <v-list v-if="result.products.filter(p => p.group == 'consumable' || p.group == 'equipment' || p.group == 'accessory').length > 0">
                            <v-list-tile v-for="(products, index) in result.products.filter(p => p.group == 'consumable' || p.group == 'equipment' || p.group == 'accessory').slice(0, 3)" :key="index" @click="searchClick(products, 'product', products.id, products.group)" class="li">
                                <avatar :item="products"></avatar>
                                <div>
                                    <p>{{products.label}}</p>
                                    <span>{{$_.find(ProductTypes,p => p.value == products.type).label}}</span>
                                </div>
                            </v-list-tile>
                        </v-list>
                        <!-- #endregion -->

                        <div v-if="result.projects.length <= 0 && result.products.length <= 0">
                            Il n'y a pas de résultat pour cette recherche
                        </div>
                    </div>

                </template>
            </template>
        </v-menu>
    </div>
</template>

<script>
    import _ 	  from 'lodash'
    import Avatar from '../../components/avatar/Avatar.vue'
    import {ProductTypes} from '../../config/enum/ProductTypes.js'
    import {ProjectStatuses} from '../../config/enum/ProjectStatuses.js'
    export default {

        components: { Avatar },

        data() {
            return {
                search_active:  false,
                search: null,
                result: [],
                pastSearches: [],
                exist: false,
                hint: 'Taper au moins 3 caractères',
                loading: false,
                ProductTypes,
                ProjectStatuses
            }
        },
        computed:{
            color(){
                if(this.search_active == true){
                    return 'active'
                }
            }
        },
        methods: {
            // when open search -- remove breadcrumbs and focus the menu with results
            open_search(){
                this.search_active = !this.search_active
                this.loading = false
                if(this.search_active == true){
                    this.hint="Taper au moins 3 caractères"
                    document.getElementById("breadcrumbs").classList.add('remove')
                    this.$nextTick(() => this.$refs.menu.isActive = true)
                    this.$nextTick(() => this.$refs.input.focus())
                } else {
                    this.search_active = false
                    this.search = null
                    document.getElementById("breadcrumbs").classList.remove('remove')
                    this.$nextTick(() => this.$refs.menu.isActive = false)
                }
            },
            // on close show breadcrumbs
            close_search(){
                this.loading = false
                this.search_active = false
                this.search = null
                document.getElementById("breadcrumbs").classList.remove('remove')
                this.$nextTick(() => this.$refs.menu.isActive = false)
            },
            // when the search input is blur
            unfocused(){
                setTimeout(()=> this.close_search(),200)
            },
            // on click in old search
            oldSearch(route, id, group = null) {
                if(group != null) {
                    this.$router.push({ name: 'single-'+ route, params: {group:group,id: id }})
                } else {
                    this.$router.push({ name: 'single-'+ route, params: {id: id }})
                }
                this.search = null
                this.dialog = false
            },
            // when click on recent search result
            searchClick(item, route, id, group = null) {
                if(group == 'consumable') {
                    group = 'consumable'
                } else if(group == 'equipment') {
                    group = 'equipment'
                } else if(group == 'accessory') {
                    group = 'accessory'
                }
                this.storeSearch(item,route,id,group)
                if(group != null) {
                    this.$router.push({ name: 'single-'+ route, params: {group:group,id: id }})
                } else {
                    this.$router.push({ name: 'single-'+ route, params: {id: id }})
                }
                this.search = null
                this.dialog = false
            },
            // store the clicked result in localStorage
            storeSearch(item, route, id, group = null){
                let pastSearches = []
                // check if the localStorage pastSearch exist
                if(localStorage["pastSearches"]) {
                    pastSearches = JSON.parse(localStorage["pastSearches"])
                    this.exist = false
                }
                // chekc if the item is already store
                pastSearches.forEach (key => {
                    if(key.id == id){
                        this.exist = true
                    }
                })

                item['route'] = route
                item['group'] = group

                if(this.exist == false) {
                    // if not put the item in the array
                    pastSearches.unshift(item)
                    // store only 10 last results, if length is supp, pop the last one
                    if(pastSearches.length > 10) {
                        pastSearches.pop();
                    }

                    localStorage["pastSearches"] = JSON.stringify(pastSearches)
                    this.pastSearches = JSON.parse(localStorage["pastSearches"])
                }
            },
            //debounce search fonction
            debounceInput: _.debounce(function (val) {
                    if (val && val.length >= 3) {
                        this.hint = ''
                            this.axios.get('/api/search/' + val)
                                .then(response => {
                                    this.result = response.data
                                    this.loading = false
                                })
                                .catch(error => {
                                    console.log(error.response.data)
                                })

                        } else {
                            this.result = []
                        }
                }, 500)
        },
        watch: {
            search(val){
                if(val){
                    this.loading = true
                    this.debounceInput(val)
                }
            }
        },
        mounted() {
            if(localStorage["pastSearches"]) {
                this.pastSearches = JSON.parse(localStorage["pastSearches"])
            }
        }
    }
</script>

<style lang="stylus" scoped>
    @require '../../assets/css/variables'
    .search {
        font-family: 'Muli', sans-serif
        letter-spacing: -0.4px
        display: flex
        align-items: center
        .btn {
            margin: 0
            border-left: 1px solid $border-light-color
            border-right: 1px solid $border-light-color
            min-width: auto
            height: $app-header-height
            &.active {
                border-right: none
                & >>> div.btn__content{
                    i.icon {
                        color: $primary-light-color
                    }
                }
            }
            & >>> div.btn__content{
                padding: 0 2.5rem
                i.icon {
                    padding: 0
                    font-size: 1.8rem
                    color: $text-color
                }
            }
        }
        .input-group {
            padding: 0
            width: 300%
            margin-left: 3rem

            & >>> .input-group__details{
                display: none
            }
        }
    }
    .last_search,
    .active_search {
        font-family: 'Muli', sans-serif
        letter-spacing: -0.4px
    }
    .last_search {
        padding-top: 1.5rem!important
        .list {
            min-height: 6rem
            display: flex
            align-items: flex-start
            flex-direction: column
            width: auto
            border-left: 2px solid $primary-light-color
            & >>> a.list__tile {
                width: 100%
                min-height: 6rem
                .avatar {
                    margin-right: 0.7rem
                }
                p {
                    margin-bottom: 0
                    font-weight: 600
                    font-size: 1.5rem
                    line-height: 1.6rem
                    margin-left: 1rem
                }
                span {
                    color: #D4DCE5
                    font-size: 1.3rem
                    font-weight: 600
                    line-height: 1.3rem
                    margin-left: 1rem
                    display: block
                }
            }
        }
    }

    .active_search {
        padding-top: 1.5rem!important
        background-color: #FFF
        .subheader{
            text-transform: uppercase
            color: $primary-light-color
            border-left: 2px solid $primary-light-color
            background-color: rgba(183, 27, 79, 0.05)
            max-height: 3.2rem
            font-weight: 600
            min-height: 3rem
            i {
                font-size: 1.7rem
            }
        }
        .li {
            min-height: 6rem
            display: flex
            align-items: center
            padding: 1rem 0.5rem
            p {
                color: #707D90
                margin-bottom: 0
                font-size: 1.5rem
                line-height: 1.6rem
                margin-left: 1rem
            }
            span{
                color: #707D90
                font-size: 1.3rem
                line-height: 1.3rem
                margin-left: 1rem
                display: inline-block
                &.chip
                &.tooltip{
                    margin-left: 0
                }
            }

        }
    }
    .chip--small {
        & >>> .chip__content {
            height:26px!important
        }
    }
</style>



// WEBPACK FOOTER //
// src/layouts/app/Search.vue